<script lang="ts" setup>
  import { useAuthStore } from '@tundr/auth';
  import {
    LifecyclePhase,
    useLifecycleHooksStore,
  } from '@tundr/lifecycle-hooks';
  import { BO_THEME_CLASS } from '@tundr/boTheme';
  import { BO_THEME_CLASS as DS_BO_THEME_CLASS } from '@tundr/ds-tokens-bo';
  import { defineAsyncComponent, onMounted, onUnmounted, watch } from 'vue';
  import { applicationWrapperClass } from './App.css';
  import GlobalElements from './GlobalElements.vue';
  import { ENV_VARS } from './core/config/env';

  const authStore = useAuthStore();
  const lifecycleHooksStore = useLifecycleHooksStore();

  watch(
    () => authStore.selectedCompany?.id,
    () => {
      lifecycleHooksStore.reset(LifecyclePhase.SESSION_INIT);
    },
  );

  const MIDDLE_MOUSE_BUTTON = 1 as const;

  const onPointerDown = (e: PointerEvent) => {
    if (e.pointerType === 'mouse' && e.button === MIDDLE_MOUSE_BUTTON) {
      e.preventDefault();
    }
  };

  onMounted(() => {
    document.body.classList.add(BO_THEME_CLASS);
    document.body.classList.add(DS_BO_THEME_CLASS);

    // Fix for middle click on Windows
    document.addEventListener('pointerdown', onPointerDown, { capture: true });
  });

  onUnmounted(() => {
    document.removeEventListener('pointerdown', onPointerDown);
  });

  const DebugPanel =
    import.meta.env.VITE_ENVIRONMENT !== 'PRODUCTION'
      ? defineAsyncComponent(() =>
          import('@tundr/debug-panel').then(({ DebugPanel }) => DebugPanel),
        )
      : null;
</script>

<template>
  <GlobalElements />
  <DebugPanel
    v-if="DebugPanel"
    :environment="ENV_VARS.environment"
    :release="ENV_VARS.release"
    :api-base-url="ENV_VARS.api.baseUrl"
  />

  <div :class="applicationWrapperClass"><router-view /></div>
</template>

<style>
  @import "@fontsource-variable/sofia-sans";
  @import "@fontsource-variable/inter";

  @import "@tundr/theme-assets/tundr-icons/tundr-icons.css";

  @import "vue-multiselect/dist/vue-multiselect.css";
</style>
